import api from "../configurations/http-common";

export const uploadFile = async (payload) => {
    let formData = new FormData();
    formData.append("file", payload.file);
    return api.securedAxios().post("/web/uploadFile", formData, {
        headers: {
            isRetry: false,
            "Content-Type": "multipart/form-data",
        },
    });
};


